module.exports = __webpack_public_path__ + "static/media/400131_02.b332db27.png";